/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { StagingAction } from './StagingAction';
import {
    StagingActionFromJSON,
    StagingActionFromJSONTyped,
    StagingActionToJSON,
    StagingActionToJSONTyped,
} from './StagingAction';

/**
 * 
 * @export
 * @interface ImportStagingRecord
 */
export interface ImportStagingRecord {
    /**
     * 
     * @type {string}
     * @memberof ImportStagingRecord
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportStagingRecord
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ImportStagingRecord
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportStagingRecord
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ImportStagingRecord
     */
    importSessionId: string;
    /**
     * 
     * @type {ImportSession}
     * @memberof ImportStagingRecord
     */
    importSession?: ImportSession;
    /**
     * 
     * @type {number}
     * @memberof ImportStagingRecord
     */
    rowIndex?: number;
    /**
     * 
     * @type {StagingAction}
     * @memberof ImportStagingRecord
     */
    action?: StagingAction;
    /**
     * 
     * @type {string}
     * @memberof ImportStagingRecord
     */
    entityType: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportStagingRecord
     */
    matchedEntityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportStagingRecord
     */
    transformedDataJson: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportStagingRecord
     */
    diffJson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportStagingRecord
     */
    validationNotes?: string | null;
}



/**
 * Check if a given object implements the ImportStagingRecord interface.
 */
export function instanceOfImportStagingRecord(value: object): value is ImportStagingRecord {
    if (!('importSessionId' in value) || value['importSessionId'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('transformedDataJson' in value) || value['transformedDataJson'] === undefined) return false;
    return true;
}

export function ImportStagingRecordFromJSON(json: any): ImportStagingRecord {
    return ImportStagingRecordFromJSONTyped(json, false);
}

export function ImportStagingRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportStagingRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'importSessionId': json['importSessionId'],
        'importSession': json['importSession'] == null ? undefined : ImportSessionFromJSON(json['importSession']),
        'rowIndex': json['rowIndex'] == null ? undefined : json['rowIndex'],
        'action': json['action'] == null ? undefined : StagingActionFromJSON(json['action']),
        'entityType': json['entityType'],
        'matchedEntityId': json['matchedEntityId'] == null ? undefined : json['matchedEntityId'],
        'transformedDataJson': json['transformedDataJson'],
        'diffJson': json['diffJson'] == null ? undefined : json['diffJson'],
        'validationNotes': json['validationNotes'] == null ? undefined : json['validationNotes'],
    };
}

export function ImportStagingRecordToJSON(json: any): ImportStagingRecord {
    return ImportStagingRecordToJSONTyped(json, false);
}

export function ImportStagingRecordToJSONTyped(value?: ImportStagingRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'importSessionId': value['importSessionId'],
        'importSession': ImportSessionToJSON(value['importSession']),
        'rowIndex': value['rowIndex'],
        'action': StagingActionToJSON(value['action']),
        'entityType': value['entityType'],
        'matchedEntityId': value['matchedEntityId'],
        'transformedDataJson': value['transformedDataJson'],
        'diffJson': value['diffJson'],
        'validationNotes': value['validationNotes'],
    };
}

